module.exports = __webpack_public_path__ + "img/menu_btn.81934461.png";